import { Navigate } from 'react-router';

// Legacy entry point — the docs flow is now driven entirely by the
// dynamic document_requirements catalog on /professional/verify-identity.
// Keep this route alive so old email links / bookmarks still land on
// something useful.
export default function SubmitPassportPage() {
  return <Navigate to="/professional/verify-identity" replace />;
}
